var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",attrs:{"role":"group"}},[_c('b-form-group',{attrs:{"label":_vm.question}},[_c('b-form-input',{model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }